import { configureStore } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux';

import auth from './auth';
import campaignCharge from './campaign-charge';
import cielo from './cielo';
import coinPayments from './coin-payments';
import coupon from './coupon';
import faq from './faq';
import game from './game';
import genericCheckout from './generic-checkout';
import mercadoPago from './mercado-pago';
import morune from './morune';
import newGameSuggestion from './new-game-suggestion';
import pagarme from './pagarme';
import paymentwall from './paymentwall';
import paypal from './paypal';
import payssion from './payssion';
import proIp from './pro-ip';
import promoCodeDiscount from './promo-code-discount';
import stripe from './stripe';
import subscription from './subscription';
import ticket from './ticket';
import trial from './trial';

export const store = configureStore({
  reducer: {
    game,
    ticket,
    auth,
    campaignCharge,
    stripe,
    pagarme,
    coupon,
    promoCodeDiscount,
    paypal,
    coinPayments,
    mercadoPago,
    subscription,
    genericCheckout,
    faq,
    trial,
    morune,
    proIp,
    newGameSuggestion,
    paymentwall,
    payssion,
    cielo,
  },
});

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
